/** @type {import('tailwindcss').Config} */

import { createThemes } from 'tw-colors';

export const primaryColor = '#C01D2E';
export const primaryColorAdmin = '#0E5A95';
export const secondaryColor = '#3D2667';
export const actionColor = '#9747FF';

export default {
  content: ['./index.html', './src/**/*.{js,ts,jsx,tsx}'],
  theme: {
    extend: {
      fontFamily: {
        sans: ['"Roboto"', 'sans-serif'],
        ubuntu: ['"Ubuntu"', 'sans-serif'],
      },
      fontSize: {
        '4.5xl': [
          '2.5rem',
          {
            lineHeight: '2.75rem',
          },
        ],
      },
      boxShadow: {
        full: '0px 0px 20px 20px',
      },
    },
  },
  plugins: [
    createThemes(
      {
        default: {
          primary: {
            400: primaryColor,
          },
          secondary: {
            400: secondaryColor,
          },
          action: {
            400: actionColor,
          },
          text: {
            secondary: 'rgba(0, 0, 0, 0.6)',
            link: 'rgba(33, 150, 243, 1)',
          },
        },
        admin: {
          primary: {
            400: primaryColorAdmin,
          },
          secondary: {
            400: secondaryColor,
          },
          action: {
            400: actionColor,
          },
          text: {
            secondary: 'rgba(0, 0, 0, 0.6)',
            link: 'rgba(33, 150, 243, 1)',
          },
        },
      },
      {
        defaultTheme: 'default',
      }
    ),
  ],
  corePlugins: {
    preflight: false,
  },
  // important: '#root',
};
